import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import { editSrgLineStatus } from "externalFeatures/store/actions/smrt/srgLinesAction";

const SrgLinesUpdateStatusButton = ({ data, disabled }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("srgLines");

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(data?.status);
  const [info, setInfo] = useState(data?.info === "—" ? "" : data?.info);

  const statusList = [
    "normal",
    "major-disruption",
    "minor-disruption",
    "upgrading-works",
  ];

  const handleSubmit = () => {
    dispatch(editSrgLineStatus({ id: data.id, status, info }));
    setOpen(false);
  };

  return (
    <>
      {/* Icon Button */}
      <IconButton
        onClick={() => setOpen(true)}
        color="primary"
        disabled={disabled}
      >
        <EditIcon />
      </IconButton>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{"Update [" + data.code + "] Service Status"}</DialogTitle>

        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
        >
          {/* Status Select */}
          <TextField
            sx={{ mt: 1 }}
            select
            label="Status"
            value={status}
            onChange={(e) => {
              setStatus(e.target.value);
              if (e.target.value === "normal") setInfo("");
            }}
            InputLabelProps={{ shrink: true }}
            fullWidth
          >
            {statusList.map((s) => (
              <MenuItem value={s}>
                <Box
                  display="flex"
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  gap={"4px"}
                >
                  <img
                    width={"25px"}
                    height={"25px"}
                    src={"/assets/" + s + ".png"}
                    alt={t("status." + s) + "Icon"}
                  />
                  <Box>{t("status." + s)}</Box>
                </Box>
              </MenuItem>
            ))}
          </TextField>

          {/* Info Input */}
          <TextField
            label="Information"
            disabled={status === "normal"}
            multiline
            minRows={3}
            maxRows={6}
            value={info}
            onChange={(e) => setInfo(e.target.value.slice(0, 500))}
            helperText={`${info.length}/500`}
            fullWidth
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!status}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SrgLinesUpdateStatusButton;
